<div class="disponibilizar-horarios-container">
  <div class="header">
    <div class="row align-items-center">
      <div class="col-md-8">
        <h1>Disponibilizar Horários</h1>
      </div>
    </div>
  </div>

  <!-- Seleção de assessor (quando abrir via menu sem parâmetros) -->
  <div class="assessor-selecao mb-4" *ngIf="!assessorSelecionado">
    <div class="card">
      <div class="card-body">
        <div class="row align-items-end">
          <div class="col-md-8">
            <label for="assessorSelecionado" class="form-label">Selecione o Assessor</label>
            <select
              id="assessorSelecionado"
              class="form-control"
              [(ngModel)]="assessorSelecionadoId">
              <option value="">Selecione...</option>
              <option *ngFor="let assessor of assessoresDisponiveis" [value]="assessor.idUsuarioEncript">
                {{ assessor.nome }}{{ assessor.email ? ' - ' + assessor.email : '' }}
              </option>
            </select>
          </div>
          <div class="col-md-4 text-end mt-3 mt-md-0">
            <button class="btn btn-primary" (click)="selecionarAssessor()">
              <i class="fa fa-check"></i> Carregar Horários
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>

  <!-- Informações do Assessor Selecionado -->
  <div class="assessor-info mb-4" *ngIf="assessorSelecionado">
    <div class="card">
      <div class="card-body">
        <div class="row align-items-center">
          <div class="col-md-8">
            <h5 class="card-title mb-1">
              <i class="fa fa-user-md me-2"></i>
              Agendando horários para: {{ assessorSelecionado.nome }}
            </h5>
            <p class="card-text text-muted mb-0">
              <i class="fa fa-envelope me-1"></i>
              {{ assessorSelecionado.email }}
            </p>
          </div>
          <div class="col-md-4 text-end">
            <span class="badge bg-primary fs-6">
              <i class="fa fa-calendar me-1"></i>
              ID: {{ assessorSelecionado.id }}
            </span>
          </div>
        </div>
      </div>
    </div>
  </div>

     <!-- Formulário -->
   <div class="formulario-container mb-4">
     <div class="card">
       <div class="card-body">
        <div class="row">
          <div class="col-md-2 col-sm-6 mb-3" *ngIf="!formData.bloquearHorario">
            <div class="form-group">
              <label for="intervalo">Intervalo (min):</label>
              <select
                id="intervalo"
                class="form-control"
                [(ngModel)]="formData.intervalo">
                <option value="15">15 min</option>
                <option value="30">30 min</option>
                <option value="45">45 min</option>
                <option value="60">60 min</option>
              </select>
            </div>
          </div>
          <div class="col-md-3 col-sm-6 mb-3" [class.col-md-4]="formData.bloquearHorario">
            <div class="form-group">
              <label for="data">Data:</label>
              <input
                type="date"
                id="data"
                class="form-control"
                [(ngModel)]="formData.data">
            </div>
          </div>
          <div class="col-md-4 col-sm-6 mb-3" [class.col-md-5]="formData.bloquearHorario">
            <div class="row">
              <div class="col-6">
                <div class="form-group">
                  <label for="horaInicio">Hora Início:</label>
                  <input
                    type="time"
                    id="horaInicio"
                    class="form-control"
                    [(ngModel)]="formData.horaInicio">
                </div>
              </div>
              <div class="col-6">
                <div class="form-group">
                  <label for="horaFim">Hora Fim:</label>
                  <input
                    type="time"
                    id="horaFim"
                    class="form-control"
                    [(ngModel)]="formData.horaFim">
                </div>
              </div>
            </div>
          </div>
          <div class="col-md-2 col-sm-6 mb-3" [class.col-md-3]="formData.bloquearHorario">
            <div class="form-group">
              <label for="tipo">Tipo:</label>
              <select
                id="tipo"
                class="form-control"
                [(ngModel)]="formData.tipo">
                <option value="presencial">Presencial</option>
                <option value="online">Online</option>
              </select>
            </div>
          </div>
          <div class="col-md-3 col-sm-6 mb-3" [class.col-md-3]="formData.bloquearHorario">
             <div class="form-group">
               <label for="bloquearHorario">Bloquear Horário:</label>
               <div class="toggle-container mt-2">
                 <label class="toggle-switch">
                   <input
                     type="checkbox"
                     id="bloquearHorario"
                     [(ngModel)]="formData.bloquearHorario">
                   <span class="toggle-slider"></span>
                 </label>
                 <span class="toggle-label">{{ formData.bloquearHorario ? 'Sim' : 'Não' }}</span>
               </div>
             </div>
           </div>
        </div>
        <div class="row">
          <div class="col-12 text-end">
            <button class="btn btn-secondary me-2" (click)="limparFormulario()">
              <i class="fa fa-times"></i> Limpar
            </button>
            <button class="btn btn-primary" (click)="adicionarHorario()">
              <i class="fa fa-plus"></i> Adicionar Horário
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>

     <!-- Tabela de Horários -->
   <div class="table-container">
     <div class="card">
       <div class="card-body">
        <div class="table-responsive">
          <table class="table table-hover">
            <thead class="table-light">
              <tr>
                <th style="width: 12%;">Data</th>
                <th style="width: 10%;">Início</th>
                <th style="width: 10%;">Fim</th>
                <th style="width: 10%;">Intervalo</th>
                <th style="width: 12%;">Bloqueado?</th>
                <th style="width: 12%;">Tipo</th>
                <th style="width: 24%;">Ações</th>
              </tr>
            </thead>
            <tbody>
              <tr *ngFor="let horario of horariosPaginados">
                <td>{{ horario.dataformatadasemhora }}</td>
                <td>{{ horario.horaformatada }}</td>
                <td>{{ horario.horafimformatada }}</td>
                <td>{{ horario.intervalominutos }} min</td>
                <td>
                  <button 
                    class="btn btn-sm status-btn" 
                    [class]="getBloqueioClass(horario.isbloqueado)"
                    (click)="alterarBloqueio(horario)"
                    [title]="'Clique para alterar status: ' + getBloqueioText(horario.isbloqueado)">
                    {{ getBloqueioText(horario.isbloqueado) }}
                  </button>
                </td>
                <td>
                  <span [class]="getTipoClass(horario.tipopresencialonline)">
                    {{ horario.tipopresencialonline }}
                  </span>
                </td>
                <td>
                  <button class="btn btn-sm btn-danger" (click)="excluirHorario(horario)" title="Excluir">
                    <i class="fa fa-trash"></i> Excluir
                  </button>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
        
        <!-- Controles de Paginação -->
        <div class="pagination-container mt-3" *ngIf="totalPages > 1">
          <div class="row align-items-center">
            <!-- Informações da paginação -->
            <div class="col-md-4">
              <div class="d-flex align-items-center">
                <label for="itemsPerPage" class="form-label me-2 mb-0">Itens por página:</label>
                <select 
                  id="itemsPerPage" 
                  class="form-select form-select-sm" 
                  style="width: auto;"
                  [(ngModel)]="itemsPerPage" 
                  (change)="alterarItensPorPagina()">
                  <option value="5">5</option>
                  <option value="10">10</option>
                  <option value="20">20</option>
                  <option value="50">50</option>
                </select>
              </div>
            </div>
            
            <!-- Informações de exibição -->
            <div class="col-md-4 text-center">
              <span class="text-muted">
                Mostrando {{ (currentPage - 1) * itemsPerPage + 1 }} a 
                {{ Math.min(currentPage * itemsPerPage, totalItems) }} de {{ totalItems }} itens
              </span>
            </div>
            
            <!-- Controles de navegação -->
            <div class="col-md-4">
              <nav aria-label="Navegação da página">
                <ul class="pagination pagination-sm justify-content-end mb-0">
                  <!-- Primeira página -->
                  <li class="page-item" [class.disabled]="currentPage === 1">
                    <button 
                      class="page-link" 
                      (click)="primeiraPagina()"
                      [disabled]="currentPage === 1"
                      title="Primeira página">
                      <i class="fa fa-angle-double-left"></i>
                    </button>
                  </li>
                  
                  <!-- Página anterior -->
                  <li class="page-item" [class.disabled]="currentPage === 1">
                    <button 
                      class="page-link" 
                      (click)="paginaAnterior()"
                      [disabled]="currentPage === 1"
                      title="Página anterior">
                      <i class="fa fa-angle-left"></i>
                    </button>
                  </li>
                  
                  <!-- Páginas numeradas -->
                  <li 
                    class="page-item" 
                    *ngFor="let pagina of getPaginasParaExibicao()"
                    [class.active]="pagina === currentPage">
                    <button 
                      class="page-link" 
                      (click)="irParaPagina(pagina)">
                      {{ pagina }}
                    </button>
                  </li>
                  
                  <!-- Próxima página -->
                  <li class="page-item" [class.disabled]="currentPage === totalPages">
                    <button 
                      class="page-link" 
                      (click)="proximaPagina()"
                      [disabled]="currentPage === totalPages"
                      title="Próxima página">
                      <i class="fa fa-angle-right"></i>
                    </button>
                  </li>
                  
                  <!-- Última página -->
                  <li class="page-item" [class.disabled]="currentPage === totalPages">
                    <button 
                      class="page-link" 
                      (click)="ultimaPagina()"
                      [disabled]="currentPage === totalPages"
                      title="Última página">
                      <i class="fa fa-angle-double-right"></i>
                    </button>
                  </li>
                </ul>
              </nav>
            </div>
          </div>
        </div>
        
        <!-- Mensagem quando não há dados -->
        <div class="text-center py-4" *ngIf="horariosFiltrados.length === 0 && !loading">
          <i class="fa fa-calendar-times fa-3x text-muted mb-3"></i>
          <h5 class="text-muted">Nenhum horário encontrado</h5>
          <p class="text-muted">Adicione horários usando o formulário acima.</p>
        </div>
      </div>
    </div>
  </div>
</div> 